import { withRouter } from 'react-router';
import { hot } from 'react-hot-loader';
import AppWrapper from 'js/components/templates/AppWrapper';
export default hot(module)(withRouter(AppWrapper));